// extracted by mini-css-extract-plugin
export default {"closeButton":"ModalConfirm_closeButton__kz6xc"};